import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'bulb-generic-alert',
  templateUrl: './generic-alert.component.html',
  styleUrls: ['./generic-alert.component.scss'],
  standalone: false,
})
export class GenericAlertComponent {
  constructor(
    public modalDialog: DynamicDialogRef,
  ) { }

  public dismiss(): void {
    this.modalDialog.close(false);
  }
}
